import React, { Suspense, useEffect } from 'react';
import './App.css';
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import ewtStore from './EWTStore';
import MainView from './components/MainView';
import 'antd/dist/antd.css';

const Data = React.lazy(() => import('./components/Data'));

const firebaseConfig = {
  apiKey: "AIzaSyCvvsWfcZ9lhh6W8qx3Xbj-QLW2555nNgo ",
  authDomain: "edwantedthis.firebaseapp.com",
  databaseURL: "https://edwantedthis.firebaseio.com",
  storageBucket: "edwantedthis.appspot.com",
  messagingSenderId: "123456789",
  projectId: "edwantedthis",
};

function isWebKitBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua);
  const isSafariDesktop =
    /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS|Chromium/.test(ua);
  return isIOS || isSafariDesktop;
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  const persistence = isWebKitBrowser()
    ? firebase.firestore().enablePersistence()
    : firebase.firestore().enablePersistence({ synchronizeTabs: true });
  persistence.catch((err) => {
    if (err.code === "failed-precondition") {
      console.warn("Firestore persistence: multiple tabs open");
    } else if (err.code !== "unimplemented") {
      console.warn("Firestore persistence:", err);
    }
  });
}

async function initializeAppData() {
  firebase.storage().ref("images").child("golfcourse.jpg").getDownloadURL().then(url => {
    ewtStore.golfcourseImageURL = url;
  });
  firebase.storage().ref("images").child("coursemap.jpg").getDownloadURL().then(url => {
    ewtStore.courseMapURL = url;
  });
  firebase.storage().ref("images").child("mapicon.png").getDownloadURL().then(url => {
    ewtStore.mapIconURL = url;
  });
  firebase.storage().ref("images").child("logo.png").getDownloadURL().then(url => {
    ewtStore.logoURL = url;
  });

  const playerID = ewtStore.getCookieValue("playerID");
  if (ewtStore.getCookieValue("fanMode") === "true") ewtStore.setFanMode(true);

  await ewtStore.setOrg("1", null);

  const tournamentID = ewtStore.org && ewtStore.org.currentTournamentID;

  if (playerID || ewtStore.fanMode) {
    if (playerID) await ewtStore.setPlayer(playerID, null);
    if (tournamentID) {
      const loaded = await ewtStore.setTournament(tournamentID, null);
      if (!loaded || !ewtStore.currentRoundID) {
        ewtStore.showView = "SETUP";
      }
    } else {
      ewtStore.showView = "SETUP";
    }
  } else {
    ewtStore.showView = "SETUP";
  }
  ewtStore.syncViewportSize();
}

function App() {
  useEffect(() => {
    ewtStore.firebaseDB = firebase.firestore();
    ewtStore.firebaseStorage = firebase.storage();

    const runInitialize = () => {
      if (!window.urlParams || !window.urlParams.data) {
        initializeAppData();
      }
    };

    firebase
      .auth()
      .signInWithEmailAndPassword("mikeupton@gmail.com", "ewt2020ewt!")
      .then(runInitialize)
      .catch((error) => {
        console.error(error);
        runInitialize();
      });

    const onBeforeInstallPrompt = (e) => {
      e.preventDefault();
      ewtStore.deferredInstallPrompt = e;
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    };
  }, []);

  if (window.urlParams && window.urlParams.data) {
    return (
      <Suspense fallback={null}>
        <Data></Data>
      </Suspense>
    );
  }

  return <MainView></MainView>;
}

export default App;
